<template>
  <div class="text-left content">
    <div class="row">
      <div class="col-lg-2 mb-2">
              <button
                class="btn btn-success col"
                @click="openModalAdd()"
              >
               Criar novo Blacklist  <font-awesome-icon icon="plus" class="pointer" />
              </button>
        </div>
        <div class="col-lg-2 mb-2 ">
              <button class="btn btn-danger col" @click="openModalImport()">
               Importar Lista <font-awesome-icon icon="file-import" class="pointer" />
              </button>
        </div>
        <div class="col-lg-2 mb-2">
              <button class="btn btn-danger col" @click="onDelete()">
               Excluir <font-awesome-icon icon="trash" class="pointer" />
              </button>
        </div>


      <div class="col-lg-6 mb-2">
        <b-input-group>
          <the-mask
            id="numero"
            @keypress.native.enter="listAll()"
            :mask="['(##) ####-####', '(##) #####-####']"
            v-model="busca"
            class="form-control"
            placeholder="Número"
          />

          <b-input-group-append>
            <b-button variant="btn-sm btn-info" style="z-index: 0" @click="listAll()">
              <font-awesome-icon icon="search" class="pointer" />
            </b-button>
          </b-input-group-append>
        </b-input-group>
      </div>
    </div>

    <div class="alert col alert-warning col mt-3" v-if="lista.length == 0">
      <strong>Atenção!</strong> Nenhum blacklist encontrado
    </div>

    <div class="page-data">
      <div class="row">
        <div class="col">
          <table class="table table-dark table-striped table-sm">
            <thead class="thead-dark">
              <tr>
                <th scope="col">
                  <b-form-checkbox v-model="selectAllStatus" @change="selectAll()"></b-form-checkbox>
                </th>
                <th scope="col">número</th>
                <th scope="col">Opção</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="ag in lista" :key="ag._id">
                <td>
                  <b-form-checkbox v-model="ag.selected"></b-form-checkbox>
                </td>
                <td>{{ag.numero | phone}}</td>
                <td>
                  <button class="btn btn-info mr-2 btn-sm" @click="openModalEdit(ag._id)">
                    <font-awesome-icon icon="edit" class="pointer" />
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <my-pagination :total="totalItens" @pageChanged="listAll($event.skip,$event.limit)"></my-pagination>
    </div>
  </div>
</template>

<script>
import jwtDecode from "jwt-decode";
import moment from "moment";
import Form from "./Form";
import Import from "./Import";

export default {
  data() {
    return {
      lista: [],
      totalItens: 0,
      form: {},
      skip: 0,
      limit: 8,
      busca: "",
      selectAllStatus: false
    };
  },
  methods: {
    selectAll() {
      for (let i = 0; i < this.lista.length; i++) {
        const el = this.lista[i];
        el.selected = !this.selectAllStatus;
      }
    },
    openModalImport() {
      this.$modal.show(
        Import,
        {},
        {
          adaptive: true,
          height: "auto",
          scrollable: true
        },
        {
          closed: () => {
            this.listAll();
          }
        }
      );
    },
    openModalAdd() {
      this.$modal.show(
        Form,
        {},
        {
          adaptive: true,
          height: "auto",
          scrollable: true
        },
        {
          closed: () => {
            this.listAll();
          }
        }
      );
    },
    openModalEdit(id) {
      this.$modal.show(
        Form,
        {
          id
        },
        {
          adaptive: true,
          height: "auto",
          scrollable: true
        },
        {
          closed: () => {
            this.listAll();
          }
        }
      );
    },
    async onDelete() {
       if (confirm("Tem certeza que deseja remover todos os selecionados?")) {
         for (let i = 0; i < this.lista.length; i++) {
        const el = this.lista[i];
        if (el.selected) {
          await this.$http.delete(`/v1/v3/nao-confiavel-v3/${el._id}`);
        }
      }
      this.listAll();
       }
    },
    async listAll(skip, limit) {
      skip = skip ? skip : this.skip;
      limit = limit ? limit : this.limit;

      const response = await this.$http.get(
        `/v1/v3/nao-confiavel-v3/${skip}/${limit}/${this.busca}`
      );
      if (response.data) {
        this.lista = response.data;
        this.totalItens = response.total;
      }
    }
  },
  async mounted() {
    this.listAll();
  }
};
</script>
